export default "__VITE_ASSET__CBivWkjk__"